import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { CreateSavedViewPayload } from '@rossum/api-client/savedViews';
import { useApiClient } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { GET_SAVED_VIEWS_QUERY } from './useGetSavedViews';

export const useCreateSavedView = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: (payload: CreateSavedViewPayload) =>
      api.request(endpoints.savedViews.create(payload)),
    onSuccess: createdView => {
      queryClient.invalidateQueries({ queryKey: [GET_SAVED_VIEWS_QUERY] });
      notify.default({
        title: intl.formatMessage(
          { id: 'containers.savedViews.drawer.notifications.created' },
          { viewName: createdView.name }
        ),
      });
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'containers.savedViews.drawer.notifications.error',
        }),
      });
    },
  });
};
